export default class NonCommodityStep {
  public widget: string = '';
  public title: string = '';
  public titleDone: string = '';
  public stepHeader: string = '';
  public stepDescription: string = '';
  public iconPending: string = '';
  public iconCurrent: string = '';
  public iconComplete: string = 'non-commodity-icon-done';
  public isDone: boolean = false;
  public isShown: boolean = false;
  public isLocked: boolean = false;

  public static withData(data: Record<any, any>): NonCommodityStep {
    return Object.assign(new NonCommodityStep(), data);
  }

  public static getStepByWidget(stepStates: NonCommodityStep[], widgetKey: string): NonCommodityStep {
    if (stepStates.length > 0) {
      for (let i = 0; i < stepStates.length; ++i) {
        if (stepStates[i].widget == widgetKey) {
          return stepStates[i];
        }
      }
    }
    return new NonCommodityStep();
  }

  public static hasPreviousStep(stepStates: NonCommodityStep[], currentStep: NonCommodityStep): boolean {
    const previousStep: NonCommodityStep = this.getPreviousStepForStep(stepStates, currentStep);
    return previousStep.widget != currentStep.widget;
  }

  public static getPreviousStep(stepStates: NonCommodityStep[]): NonCommodityStep {
    const currentStep: NonCommodityStep = this.getCurrentStep(stepStates);
    return this.getPreviousStepForStep(stepStates, currentStep);
  }

  public static getPreviousStepForStep(
    stepStates: NonCommodityStep[],
    currentStep: NonCommodityStep
  ): NonCommodityStep {
    if (stepStates.length > 0) {
      let previousStep = stepStates[0];
      for (let i = 0; i < stepStates.length; ++i) {
        if (stepStates[i].widget == currentStep.widget && stepStates[i - 1]) {
          previousStep = stepStates[i - 1];
        }
      }
      return previousStep;
    }
    return new NonCommodityStep();
  }

  public static getNextStep(stepStates: NonCommodityStep[]): NonCommodityStep {
    const currentStep: NonCommodityStep = this.getCurrentStep(stepStates);
    return this.getNextStepForStep(stepStates, currentStep);
  }

  public static getNextStepForStep(stepStates: NonCommodityStep[], currentStep: NonCommodityStep): NonCommodityStep {
    if (stepStates.length > 0) {
      let nextStep = stepStates[0];
      for (let i = 0; i < stepStates.length; ++i) {
        if (stepStates[i].widget == currentStep.widget && stepStates[i + 1]) {
          nextStep = stepStates[i + 1];
        }
      }
      return nextStep;
    }
    return new NonCommodityStep();
  }

  public static getCurrentStep(stepStates: NonCommodityStep[]): NonCommodityStep {
    if (stepStates.length > 0) {
      for (let i = 0; i < stepStates.length; ++i) {
        if (stepStates[i].isShown) {
          return stepStates[i];
        }
      }
      return stepStates[0];
    }
    return new NonCommodityStep();
  }

  public static getActiveStepWidgets(stepStates: NonCommodityStep[]): string[] {
    const activeStepWidgets: string[] = [];
    if (stepStates.length > 0) {
      for (let i = 0; i < stepStates.length; ++i) {
        if (stepStates[i].isShown) {
          for (let j = 0; j <= i; ++j) {
            activeStepWidgets.push(stepStates[j].widget);
          }
          return activeStepWidgets;
        }
      }
    }
    return activeStepWidgets;
  }

  public static isStepCurrent(stepStates: NonCommodityStep[], widgetKey: string): boolean {
    const currentStep: NonCommodityStep = NonCommodityStep.getCurrentStep(stepStates);
    return currentStep.widget == widgetKey;
  }

  public static isStepActive(stepStates: NonCommodityStep[], widgetKey: string): boolean {
    const activeStepWidgets: string[] = NonCommodityStep.getActiveStepWidgets(stepStates);
    return activeStepWidgets.indexOf(widgetKey) >= 0;
  }

  public static isStepLocked(stepStates: NonCommodityStep[], widgetKey: string): boolean {
    const step: NonCommodityStep = NonCommodityStep.getStepByWidget(stepStates, widgetKey);
    return step.isLocked;
  }

  public static isStepDisabled(stepStates: NonCommodityStep[], widgetKey: string): boolean {
    const step: NonCommodityStep = NonCommodityStep.getStepByWidget(stepStates, widgetKey);
    const previousStep: NonCommodityStep = NonCommodityStep.getPreviousStepForStep(stepStates, step);
    return !previousStep.isDone;
  }

  public static getStepIconClass(stepStates: NonCommodityStep[], widgetKey: string): string {
    const step: NonCommodityStep = NonCommodityStep.getStepByWidget(stepStates, widgetKey);
    if (this.isStepActive(stepStates, widgetKey) && (!step.isShown || step.isLocked) && step.isDone) {
      if (step.iconComplete && step.iconComplete.length > 0) {
        return 'non-commodity-icon ' + step.iconComplete;
      }
    }
    if (step.isShown && step.iconCurrent.length > 0) {
      return 'non-commodity-icon ' + step.iconCurrent;
    }
    if (step.iconPending && step.iconPending.length > 0) {
      return 'non-commodity-icon ' + step.iconPending;
    }
    return '';
  }
}
